import React, { useState } from "react";
import { ModalBody, Modal } from "reactstrap";
import styles from "./locationdetail.module.scss";
import AddSpotsModal from "../AddSpotsModal";
import { useSelector } from "react-redux";

const LocationDetailModal = ({ locationId, openModal, toggle, setLoading }) => {
  const [openSpotsModal, setOpenSpotsModal] = useState(false);
  const locationData = useSelector((state) => state?.appReducer)?.locations;
  const currentLocation = locationData?.find((data) => data?.id === locationId);
  const spotsArray = currentLocation?.spots || [];
  const spotsNamesArray = spotsArray?.map((spot) => spot?.name);
  const spotsNames =
    spotsNamesArray?.length > 1
      ? spotsNamesArray?.join(",")
      : spotsNamesArray?.[0]
      ? spotsNamesArray?.[0]
      : "-";
  const toggleSpotsModal = () => {
    setOpenSpotsModal(!openSpotsModal);
  };
  return (
    <>
      {openSpotsModal ? (
        <AddSpotsModal
          openModal={openSpotsModal}
          toggle={toggleSpotsModal}
          locationId={String(locationId || "")}
          setLoading={setLoading}
        />
      ) : (
        <Modal
          isOpen={openModal}
          toggle={() => {
            toggle();
          }}
          centered
          fullscreen="sm"
          contentClassName={styles["modal_content"]}
          className={styles["container"]}
          wrapClassName={styles["modal_wrapper"]}
          backdrop={true}
          backdropClassName={styles["modal-backdrop-style"]}
        >
          <ModalBody className={styles["modal_location_body"]}>
            <div className={styles["header_content"]}>
              <div className={styles["header_container"]}>
                <p className={styles["header_heading"]}>
                  {currentLocation?.name || "-"}
                </p>
              </div>
              <div>
                <button
                  className={styles["add_spots_button"]}
                  onClick={() => {
                    setOpenSpotsModal(true);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M6 12H18"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M12 18V6"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>{" "}
                  Add Spot
                </button>
              </div>
            </div>

            <div className={styles["content_wrapper"]}>
              <div className={styles["label_data_container"]}>
                <p className={styles["label_data_header"]}>
                  Global Location Number
                </p>
                <p className={styles["label_data_paragraph"]}>
                  {currentLocation?.globalLocationNumber || "-"}
                </p>
              </div>

              <div className={styles["label_data_container"]}>
                <p className={styles["label_data_header"]}>Country</p>
                <p className={styles["label_data_paragraph"]}>
                  {" "}
                  {currentLocation?.country || "-"}
                </p>
              </div>
            </div>

            <div className={styles["content_wrapper"]}>
              <div
                className={styles["label_data_container"]}
                style={{
                  width: "100%",
                }}
              >
                <p className={styles["label_data_header"]}>Brand</p>
                <p className={styles["label_data_paragraph"]}>
                  {currentLocation?.brand || "-"}
                </p>
              </div>
            </div>

            <div className={styles["lower_border"]} />
            <div>
              <p className={styles["label_data"]}>Spots: {spotsNames || "-"}</p>
            </div>
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

export default LocationDetailModal;
